<template>
  <div
    :class="[
      'manualAddToBasket',
      { 'manualAddToBasket--small': small },
      { 'manualAddToBasket--availableStock': availableStock },
    ]"
  >
    <div class="manualAddToBasket__amountWrapper">
      <div v-if="availableStock" class="manualAddToBasket__stock">
        Dostępnych<br />
        <b>{{ availableStock }} {{ uom }}</b>
      </div>
      <div class="manualAddToBasket__amount">
        <button
          class="manualAddToBasket__amountButton manualAddToBasket__amountButton--minus"
          @click="minus"
        >
          <span></span>
        </button>
        <div class="manualAddToBasket__count">
          <div class="manualAddToBasket__countInner">
            <input
              type="number"
              v-model="count"
              placeholder="0"
              class="manualAddToBasket__input"
              @keyup.enter="onEnter"
              @input="onInput"
            />
            <span
              ref="countText"
              class="manualAddToBasket__countText"
              :class="{ 'formCountInput__countText--empty': count === '' }"
              style="opacity: 0"
            >
              {{ uom }}
            </span>
          </div>

          <div class="manualAddToBasket__countInfo">
            <span class="manualAddToBasket__countNumber">
              {{ count }}
            </span>
            <span
              ref="countText"
              class="manualAddToBasket__countText"
              :class="{ 'formCountInput__countText--empty': count === '' }"
            >
              {{ uom }}
            </span>
          </div>
        </div>
        <button
          class="manualAddToBasket__amountButton manualAddToBasket__amountButton--plus"
          @click="plus"
        >
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
    <v-button
      :text="editOrderId ? orderButtonText : buttonText"
      theme="purple"
      full-width
      small-height
      :is-loading="isLoading"
      :disabled="disabled || !canBeOrdered"
      @click="$emit('addToBasket', count)"
    />
  </div>
</template>

<script>
import cartMixin from '@/mixins/cart';
import VButton from '~/components/VButton';

export default {
  name: 'ManualAddToBasket',
  components: {
    VButton,
  },
  mixins: [cartMixin],
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    availableStock: {
      type: Number,
      default: 0,
    },
    uom: {
      type: String,
      default: 'szt.',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    orderButtonText: {
      type: String,
      default: 'Dodaj do zamówienia',
    },
    buttonText: {
      type: String,
      default: 'Dodaj do koszyka',
    },
    canBeOrdered: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      count: 1,
    };
  },
  methods: {
    onEnter() {
      this.$emit('enter');
    },
    onInput() {
      // if (this.availableStock && this.count > this.availableStock) {
      //   this.count = this.availableStock;
      //   this.$emit('change', this.count);
      // }
      // this.count = this.availableStock;
      this.$emit('change', this.count);
    },
    plus() {
      // if (this.availableStock) {
      //   if (this.count < this.availableStock) {
      //     this.count++;
      //   } else {
      //     this.count = this.availableStock;
      //   }
      // } else {
      //   this.count++;
      // }

      this.count++;

      this.$emit('change', this.count);
    },
    minus() {
      if (this.count >= 1) {
        this.count--;
      }
      this.$emit('change', this.count);
    },
  },
};
</script>

<style lang="scss" scoped>
.manualAddToBasket {
  $root: &;
  width: 100%;
  display: flex;
  min-width: 15rem;
  position: relative;

  &__amount {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid $cAddLight;
    border-radius: 3px;
    height: 5rem;
  }

  &__count {
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
  }

  &__countInner {
    display: flex;
  }

  &__input {
    width: 100%;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 600;
    overflow: hidden;
    text-align: center;

    &::placeholder {
      color: $cMainDark;
      font-weight: 600;
    }

    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  &__countInfo {
    pointer-events: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &__countNumber {
    opacity: 0;
  }

  &__countText {
    &--empty {
      padding-left: 1.1rem;
    }
  }

  &__stock {
    font-size: 1.3rem;
    line-height: 1.6rem;

    b,
    strong {
      font-weight: 700;
    }
  }

  &__amountWrapper {
    flex: 0 0 50%;
    margin-right: 1rem;
  }

  &__amountButton {
    position: relative;
    width: 4rem;
    height: 100%;
    flex: 0 0 4rem;
    color: $cMain;
    transition: color $tr;

    &--minus {
      border-right: 1px solid $cAddLight;

      span {
        width: 1.6rem;
        height: 2px;
        background-color: currentColor;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &--plus {
      border-left: 1px solid $cAddLight;

      span {
        width: 1.6rem;
        height: 2px;
        background-color: currentColor;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        &:nth-child(2) {
          transform: translate(-50%, -50%) rotate(90deg);
        }
      }
    }

    &:hover {
      color: $cSec;
    }
  }

  &--small {
    min-width: 12.5rem;

    #{$root}__amount {
      height: 3.2rem;
    }

    #{$root}__input,
    #{$root}__count {
      font-size: 1.2rem;
    }
  }

  &--availableStock {
    flex-direction: column;

    #{$root}__amountWrapper {
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
    }

    #{$root}__stock {
      flex: 0 0 40%;
    }

    #{$root}__amount {
      flex: 1;
    }
  }
}
</style>
